import {WINDOW} from '../constants/environment'
import {isLocalStorageSupported} from './persist'

const hourToMs = ms => ms * 3600000

const expireAfterHours = time => ({timestamp}) => {
  const cacheLife = hourToMs(time) // 30 minute cache
  timestamp = parseInt(timestamp)
  const now = new Date().getTime()
  return now - timestamp > cacheLife
}

export async function cacheApiResponse(cacheKey, api, invalidateCache = expireAfterHours(0.5)) {
  if (WINDOW && isLocalStorageSupported()) {
    const cache = WINDOW.localStorage.getItem(cacheKey)
    if (cache) {
      const {timestamp, data} = JSON.parse(cache)
      if (!invalidateCache({timestamp, storedData: data})) {
        return {response: data}
      }
    }
  }
  const {data} = await api()
  if (WINDOW && isLocalStorageSupported()) {
    const timestamp = new Date().getTime()
    WINDOW.localStorage.setItem(cacheKey, JSON.stringify({data, timestamp}))
  }
  return {response: data}
}



// WEBPACK FOOTER //
// ./src/apis/api-cache.js